import {h, Fragment} from "preact"
import { useSelectedFiltersCount } from "@nosto/preact"

export default function MobileFilterButton({ onClick }) {
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleClick = (e) => {
        e.preventDefault()
        onClick()
    }

    return (
        <div class="mobile-facets__open-wrapper focus-offset" onClick={handleClick}>
            <span class="mobile-facets__open">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M4 21H28" stroke="#333333" stroke-linejoin="round" />
                    <path d="M0 11H32" stroke="#333333" stroke-linejoin="round" />
                </svg>
                <span class="mobile-facets__open-label Button-A button-label medium-hide large-up-hide">Filter</span>
                {selectedFiltersCount > 0 && <span class="P-14">({selectedFiltersCount})</span>}
                <span class="mobile-facets__open-label button-label small-hide">Filter</span>
            </span>
        </div>
    )
} 